<template>
  <v-dialog :value="dialog" max-width="1000" @click:outside="close" @keydown.esc="close">
    <v-card v-if="payslip || loader">
      <v-card-title>
        <span class="headline">{{ fileName }}</span>
        <v-spacer></v-spacer>
        <v-btn icon :disabled="!url" @click="download">
          <v-icon>mdi-download</v-icon>
        </v-btn>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <div v-if="loading" class="text-center py-10">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <iframe v-else-if="url" :src="url" style="width: 100%; height: 75vh; border: none"></iframe>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { payslipService } from "@/libs/ws/payslipService";

export default {
  props: {
    dialog: Boolean,
    payslip: Object,
    // Alternativa a payslip (filas de la carga masiva): funcion que devuelve la promesa del PDF y su nombre
    loader: Function,
    file_name: String,
  },
  data() {
    return {
      url: null,
      loading: false,
    };
  },
  computed: {
    fileName() {
      return this.loader ? this.file_name : this.payslip.file_name;
    },
  },
  watch: {
    dialog(value) {
      if (value) this.load();
      else this.revoke();
    },
  },
  beforeDestroy() {
    this.revoke();
  },
  methods: {
    load() {
      this.revoke();
      this.loading = true;
      (this.loader ? this.loader() : payslipService.file(this.payslip.id))
        .then((response) => {
          if (response.status) {
            this.url = URL.createObjectURL(response.blob);
          } else {
            this.$toast.error(response.msg, "Error");
            this.close();
          }
        })
        .catch((e) => {
          console.log(e);
          this.$toast.error("No se pudo abrir el recibo.", "Error");
          this.close();
        })
        .finally(() => (this.loading = false));
    },
    revoke() {
      if (this.url) URL.revokeObjectURL(this.url);
      this.url = null;
    },
    download() {
      const link = document.createElement("a");
      link.href = this.url;
      link.download = this.fileName;
      link.click();
    },
    close() {
      this.$emit("updateDialog", false);
    },
  },
};
</script>
